@if (showModal) {
<app-dialog-title>Schedule Draft package generation</app-dialog-title>
<mat-dialog-content class="content">
  @if (errorMessage) {
  <p class="error-message">{{ errorMessage }}</p>
  } @if (scheduleActionState !== 'COMPLETED') {
  <div>
    <p>This task will need to run after the following task completes:</p>
    @if (runningTasksList?.length > 0) {
    <div>
      <label>Current Running Generation Tasks: </label>
      <br />
      <div class="ui search selection dropdown" #runningTasksDropDown>
        <div class="text"></div>
        <div class="menu"></div>
        <i class="chevron down icon"></i>
      </div>
      <input type="hidden" [formControl]="runningTasks" />
    </div>
    } @if (runningTasksList?.length === 0) {
    <div>
      <p>There is no current running generation task.</p>
    </div>
    }
    <br />
    @if (queuedTasksList?.length > 0) {
    <div>
      <label>Other Queued Tasks: </label>
      <br />
      <div class="ui search selection dropdown" #queuedTasksDropDown>
        <div class="text"></div>
        <div class="menu"></div>
        <i class="chevron down icon"></i>
      </div>
      <input type="hidden" [formControl]="queuedTasks" />
    </div>
    } @if (queuedTasksList?.length === 0) {
    <div>
      <p>There is no current queued generation task.</p>
    </div>
    }
  </div>
  } @if (scheduleActionState === 'COMPLETED') {
  <div>
    <p>Bulk generate package process has been scheduled.</p>
    <p>
      The "Generate package" and "Download package" buttons are disabled during
      the process, they will be re-enabled once package generation is finished.
    </p>
  </div>
  }
</mat-dialog-content>
@if (scheduleActionState !== 'COMPLETED') {
<mat-dialog-actions align="end">
  <a class="go-back cancel" (click)="onClose()">Cancel</a>
  @if (runningTasksList?.length > 0 || queuedTasksList?.length > 0) {
  <button
    class="ui primary button"
    (click)="scheduleGeneration()"
    [disabled]="submitButtonDisabled"
    [ngClass]="{ loading: scheduleActionState === 'LOADING' }"
  >
    Schedule
  </button>
  }
</mat-dialog-actions>
} @if (scheduleActionState === 'COMPLETED') {
<mat-dialog-actions align="end">
  <button class="ui primary button" (click)="onClose(true)">Ok</button>
</mat-dialog-actions>
} }
